<template>
    <div class="weblist_wrap">
        <div class="top_wrap">
            <div class="tools_wrap" v-if="
                    tableConfig.queryConfig &&
                    JSON.stringify(tableConfig.queryConfig) != '{}'
                ">
                <div class="slot_wrap">
                    <div class="query_wrap" v-if="
                            tableConfig.queryConfig &&
                            JSON.stringify(tableConfig.queryConfig) != '{}'
                        ">
                        <div class="query_item_wrap">
                            <div class="query_item" v-if="
                                    item.label &&
                                    item.kjlx &&
                                    index != 'undefined' &&
                                    !item.hidden
                                " v-for="(item, index) in tableConfig.queryConfig"
                                :class="item.width" :key="index"
                                :style="{'flex':['datetimerange','daterange'].indexOf(item.kjlx) == -1 ? '0 0 290px':'0 0 450px'}">
                                <!-- 340px 450-->
                                <div class="lab" :style="{
                                        flex:
                                            '0 0 ' +
                                            (tableConfig.queryLabelWidth
                                                ? tableConfig.queryLabelWidth
                                                : 90) +
                                            'px',
                                    }">
                                    {{ item.label }}：
                                </div>
                                <div class="con">
                                    <vxe-input v-if="item.kjlx == 'input'" class="my_inp"
                                        v-model="item.value" :placeholder="'请输入' + item.label"
                                        size="small"></vxe-input>
                                    <vxe-radio-group v-if="item.kjlx == 'radio'"
                                        v-model="item.value">
                                        <vxe-radio v-for="(item2, index2) in item.list"
                                            :key="index2" :label="item2.value"
                                            :content="item2.label"></vxe-radio>
                                    </vxe-radio-group>
                                    <vxe-select v-if="item.kjlx == 'select'" v-model="item.value"
                                        :placeholder="'请输入' + item.label" size="mini"
                                        class="my_inp">
                                        <vxe-option v-for="(item2, index2) in item.list"
                                            :value="item2.value" :label="item2.label"></vxe-option>
                                    </vxe-select>
                                    <el-date-picker v-if="item.kjlx == 'date'" v-model="item.value"
                                        :placeholder="'请选择' + item.label" value-format="yyyy-MM-dd"
                                        class="my_inp" size="mini" type="date"></el-date-picker>
                                    <el-date-picker v-if="item.kjlx == 'daterange'"
                                        v-model="item.rangeValue" :placeholder="'请选择' + item.label"
                                        value-format="yyyy-MM-dd" class="my_inp" size="mini"
                                        range-separator="至" start-placeholder="开始日期"
                                        end-placeholder="结束日期" type="daterange"
                                        @change="changeRange($event, item)" style="width:340px">
                                    </el-date-picker>

                                    <el-date-picker v-if="item.kjlx == 'datetime'"
                                        v-model="item.value" :placeholder="'请选择' + item.label"
                                        value-format="yyyy-MM-dd HH:mm:ss" class="my_inp"
                                        size="mini" type="datetime" style="width:240px">
                                    </el-date-picker>
                                    <el-date-picker v-if="item.kjlx == 'datetimerange'"
                                        v-model="item.rangeValue" :placeholder="'请选择' + item.label"
                                        value-format="yyyy-MM-dd HH:mm:ss" class="my_inp"
                                        size="mini" range-separator="至" start-placeholder="开始时间"
                                        end-placeholder="结束时间" type="datetimerange"
                                        @change="changeRange($event, item)" style="width:340px">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="query_btn_wrap" :class="tableConfig.queryBtnWidth || 'w_33'"
                            style="flex: 0 0 300px">
                            <div class="query_btn">
                                <div class="showToggle" @click="toggleQuery" v-if="
                                        originQueryHidden.length &&
                                        tableConfig.showMore
                                    ">
                                    {{ toggleQueryStatus ? "收起" : "展开" }}
                                    <i class="el-icon-arrow-down" v-if="!toggleQueryStatus"></i>
                                    <i class="el-icon-arrow-up" v-if="toggleQueryStatus"></i>
                                </div>
                                <vxe-button class="my_btn my_reset" size="mini" @click="resetQuery">
                                    重置</vxe-button>
                                <vxe-button class="my_btn" status="primary" size="mini"
                                    @click="query">查询</vxe-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table_wrap">

                <div class="table_btn_wrap" v-if="tableConfig.buttonList.length">
                    <slot name="btns"></slot>
                    <!--
                         content="默认颜色"
           status="primary" content="主要颜色"
           status="success" content="成功颜色"
           status="info" content="信息颜色"
           status="warning" content="警告颜色"
           status="danger" content="危险颜色" class="my_btn"-->
                    <vxe-button class="cus-btn" v-for="(item, index) in tableConfig.buttonList"
                        :key="index" :status="item.status || 'primary'" size="mini" v-if="
                            (tableConfig.noRole ? true : formatBtn(item.id)) &&
                            item.name &&
                            !item.hidden
                        " :content="
                            tableConfig.noRole
                                ? item.name
                                : buttonObj[formatBtn(item.id)]
                        " :disabled="loading" @click="btnClickHandle(item)"></vxe-button>
                </div>
                <div class="table_content_wrap">
                    <vxe-table class="my_table" ref="my_table" :key="tableKey" :data="rows" border
                        show-header-overflow show-overflow highlight-hover-row height="auto"
                        auto-resize stripe round resizable :loading="loading"
                        :checkbox-config="checkboxConfig" :radio-config="radioConfig"
                        header-row-class-name="my_head"
                        :show-footer="JSON.stringify(footer) != '{}'" @cell-click="cellClick"
                        @cell-dblclick="dblRowHandle" style="min-height:300px">
                        <vxe-table-column width="50" v-if="!tableConfig.singleselect"
                            type="checkbox" field="my_check" align="center">
                        </vxe-table-column>
                        <vxe-table-column width="50" v-if="tableConfig.singleselect" type="radio"
                            field="my_check" align="center"></vxe-table-column>
                        <vxe-table-column align="center" type="seq" title="序号" width="60"
                            field="index"></vxe-table-column>
                        <vxe-table-column v-if="!item.hidden" min-width="80"
                            v-for="(item, index) in tableConfig.listConfig" :key="index"
                            :field="item.zdname" :title="item.label" :align="
                                tableConfig.align ? tableConfig.align : 'center'
                            " :width="item.width || null" :fixed="item.fixed ? 'right' : null">
                            <template #default="{ row, rowIndex }">
                                <div v-if="item.formatFunc">
                                    <div class="cell-ellipsis" v-html="
                                            formatFunc(
                                                row,
                                                item.zdname,
                                                item.formatFunc
                                            )
                                        "></div>
                                </div>
                                <div v-if="!item.formatFunc">
                                    <div v-if="!item.format" class="cell-ellipsis"
                                        :title="row[item.zdname]">
                                        {{ row[item.zdname] }}
                                    </div>
                                    <div v-if="item.format" class="cell-ellipsis"
                                        :title="item.format(row[item.zdname])">
                                        {{ item.format(row[item.zdname]) }}
                                    </div>
                                </div>
                                <div v-if="item.tableButtonList">
                                    <template v-for="(item2, index2) in item.tableButtonList">
                                        <el-button class="my_btn" :key="index2" size="mini" v-if="formatTableBtn(item2, row) &&
                                            ((item.tableButtonList.length > 3 && index2<2) ||
                                            (item.tableButtonList.length <= 3))"
                                            :content="item2.name" :type="item2.type || 'primary'"
                                            plain @click.stop="
                                            handleTablebtnClick( row,item2['func'])">
                                            {{ item2.name }}
                                        </el-button>
                                    </template>

                                    <el-dropdown v-if="item.tableButtonList.length>3">
                                        <span class="el-dropdown-link"
                                            style="padding-left:10px;cursor: pointer;">
                                            更多<i class="el-icon-arrow-down el-icon--right"></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <div class="flex"
                                                style="flex-direction: column;padding:0 10px">
                                                <template
                                                    v-for="(item2, index2) in item.tableButtonList">
                                                    <el-link class="my-link" :underline="false"
                                                        :key="index2" size="mini"
                                                        v-if="formatTableBtn(item2, row) && index2>=2"
                                                        :content="item2.name"
                                                        :type="item2.type || 'primary'" plain
                                                        @click.stop="handleTablebtnClick( row,item2['func'])">
                                                        {{ item2.name }}
                                                    </el-link>
                                                </template>
                                            </div>

                                        </el-dropdown-menu>
                                    </el-dropdown>

                                </div>
                            </template>
                        </vxe-table-column>

                        <slot></slot>
                    </vxe-table>
                </div>
            </div>
        </div>
        <div class="footer_wrap" v-if="tableConfig.page !== false">
            <vxe-pager perfect :current-page.sync="pageIndex" :page-size.sync="pageSize"
                :loading="loading" :total="total" :page-sizes="[20, 50, 100, 1000]" :layouts="[
                    'PrevJump',
                    'PrevPage',
                    'Number',
                    'NextPage',
                    'NextJump',
                    'Sizes',
                    'FullJump',
                    'Total',
                ]" @page-change="pageChange">
                <template #left>
                    <vxe-button size="small" @click="getData">
                        <template #default>
                            <i :class="{
                                    'el-icon-refresh': !loading,
                                    'el-icon-loading': loading,
                                }"></i>
                        </template>
                    </vxe-button>
                </template>
            </vxe-pager>
        </div>
    </div>
</template>

<script>
import $api from "@/api/public";

export default {
  // props:['tableConfig'],
  props: {
    tableConfig: {
      type: Object,
      required: true,
      default: {},
    },
  },
  name: "CommonWeblistCompNew",

  data() {
    return {
      initParams: {},
      param: "",
      timeout: null,
      buttonList: [],
      zdzdList: [],
      footer: {},
      rows: [],
      total: 0,
      form: {},
      pageIndex: 1,
      pageSize: 20,
      filterRules: [
        { label: "等于", value: "equal" },
        { label: "包含", value: "contains" },
        { label: "不等于", value: "notequal" },
        { label: "匹配开头", value: "beginwith" },
        { label: "匹配结尾", value: "endwith" },
      ],
      singleselect: false,
      loading: false,
      tableKey: 1,
      checkboxConfig: {},
      radioConfig: {},
      originQueryValueObj: {},
      originQueryHidden: [],
      toggleQueryStatus: false,
    };
  },
  computed: {
    buttonIds() {
      return this.$route.meta.buttonIds;
    },
    buttonObj() {
      var obj = {};
      this.$route.meta.button.forEach((e) => {
        obj[e.menuId + ""] = e.name;
      });
      return obj;
    },
  },
  methods: {
    getResult() {
      var f = JSON.parse(JSON.stringify(this.formConfig.form));
      var value = {};
      var emptyArr = [];
      var zbRequireObj = {};
      var cbRequireObj = {};
      var selectsArr = [];
      var empty = false;
      for (var i in f) {
        if (f[i].kjlx == "selects") {
          value[i] = f[i].value ? f[i].value.join(",") : null;
        } else {
          value[i] = f[i].value;
        }
        zbRequireObj[i] = f[i].required;

        if (f[i].kjlx == "hasChildren") {
          var c = f[i].config;
          for (var j in c) {
            cbRequireObj[j] = c[j].required;
          }
        }
      }
      for (var i in value) {
        if (value[i] instanceof Array) {
          if (!value[i].length && zbRequireObj[i]) {
            empty = true;
          } else {
            value[i].forEach((e) => {
              for (var j in e) {
                if (
                  !e[j] &&
                  e[j] !== false &&
                  e[j] !== 0 &&
                  cbRequireObj[j]
                ) {
                  empty = true;
                }
              }
            });
          }
        } else {
          if (
            !value[i] &&
            value[i] !== false &&
            value[i] !== 0 &&
            zbRequireObj[i]
          ) {
            empty = true;
          }
        }
      }
      if (empty) {
        this.$message.warning("有必填项为空，不能保存！");
        return false;
      } else {
        return value;
      }
    },
    formatTableBtn(item, row) {
      if (item.hidden === true) {
        return false;
      } else if (typeof item.hidden == "string") {
        return !this.$parent[item.hidden](row);
      } else {
        return true;
      }
    },
    toggleQuery() {
      var q = this.tableConfig.queryConfig;
      for (var i in q) {
        if (!this.toggleQueryStatus) {
          this.$set(q[i], "hidden", false);
        } else {
          if (this.originQueryHidden.includes(i)) {
            this.$set(q[i], "hidden", true);
          } else {
            this.$set(q[i], "hidden", false);
          }
        }
      }
      this.toggleQueryStatus = !this.toggleQueryStatus;
    },
    changeRange(val, item) {
      if (val) {
        item.value = val.join("/");
      } else {
        item.value = "";
      }

      if (item.funcName) {
        var obj = this.$parent[item.funcName](val);
        var tmp;
        for (var key in obj) {
          tmp = this.tableConfig.queryConfig[key];
          if (tmp) {
            tmp.value = obj[tmp.zdname];
          }
        }
        // this.tableConfig.urlConfig.param = Object.assign(this.tableConfig.urlConfig.param, temp)
      }
    },
    pageChange({ type }) {
      if (type == "current") {
        this.getData();
      }
      if (type == "size") {
        this.pageIndex = 1;
        this.getData();
      }
    },
    btnClickHandle(item) {
      if (this.tableConfig.env == "iframe") {
        if (item.funcName && window[item.funcName]) {
          window[item.funcName](this.chosen());
        } else if (item.func) {
          item.func(this.chosen());
        }
      } else {
        if (item.funcName && this.$parent[item.funcName]) {
          this.$parent[item.funcName](this.chosen());
        } else if (item.func) {
          item.func(this.chosen());
        }
      }
    },
    handleTablebtnClick(row, func) {
      if (func && this.$parent[func]) {
        this.$parent[func](row);
      }
    },
    resetQuery() {
      this.tableConfig.queryConfig = JSON.parse(
        JSON.stringify(this.initParams)
      );
      console.log(JSON.stringify(this.tableConfig.queryConfig));
      for (var i in this.tableConfig.queryConfig) {
        var l = this.tableConfig.queryConfig[i].list;
        if (l && l.length && !l.find((e) => !e.value)) {
          this.tableConfig.queryConfig[i].value = l[0].value;
          this.$emit("change-tab", l[0].value);
        } else {
          this.tableConfig.queryConfig[i].value =
            this.originQueryValueObj[i];
          this.$emit("change-tab", this.originQueryValueObj[i]);
        }
        this.tableConfig.queryConfig[i].rangeValue = [];
      }

      this.query();
    },
    query() {
      this.pageIndex = 1;
      this.getData();
    },
    formatFunc(row, value, func) {
      if (this.tableConfig.env == "iframe") {
        if (window[func]) {
          return window[func](row, value);
        } else {
          return "";
        }
      }
      if (this.tableConfig.env == "vue") {
        if (this.$parent[func]) {
          return this.$parent[func](row, value);
        } else {
          return "";
        }
      }
    },
    formatBtn(id) {
      if (!(id instanceof Array)) {
        id = [];
      }
      var arr = id.filter((e) => {
        return this.buttonIds.includes(e);
      });
      return arr[0];
    },
    refresh() {
      this.pageIndex = 1;
      this.getData();
    },
    cellClick({ row, column, cell, event }) {
      if (this.tableConfig.cellClick && this.$parent[this.tableConfig.cellClick]) {
        this.$parent[this.tableConfig.cellClick]({
          row, column,
          cell
        });
      }
    },
    dblRowHandle: function ({ row }) {
      console.log(row);
      if (this.tableConfig.dblClick) {
        if (
          this.tableConfig.env == "iframe" &&
          window[this.tableConfig.dblClick]
        ) {
          window[this.tableConfig.dblClick](row);
        }

        if (
          this.tableConfig.env == "vue" &&
          this.$parent[this.tableConfig.dblClick]
        ) {
          this.$parent[this.tableConfig.dblClick](row);
        }
      }
    },
    setSelectCell: function ({ row }) {

      if (this.tableConfig.setSelectCell) {
        return this.$parent[this.tableConfig.setSelectCell](row);
      }
    },
    chosen() {
      if (this.tableConfig.singleselect) {
        return this.$refs["my_table"].getRadioRecord();
      } else {
        return this.$refs["my_table"].getCheckboxRecords();
      }
    },
    getData() {
      if (!this.tableConfig.urlConfig.url) {
        return;
      }
      this.loading = true;
      let obj = {
        ...this.tableConfig.urlConfig.param,
      };
      let where = {};
      obj[this.tableConfig.urlConfig.page] = this.pageIndex;
      obj[this.tableConfig.urlConfig.limit] = this.pageSize;
      if (this.tableConfig.queryConfig) {
        for (var i in this.tableConfig.queryConfig) {
          var val = this.tableConfig.queryConfig[i].value;
          if (val == "") {
            val = null;
          }
          obj[i] = val;
        }
      }
      // obj.where = JSON.stringify(where);
      $api(this.tableConfig.urlConfig.url, obj).then(res => {


        let d = null;
        //   if (res.data instanceof Array) {
        if (this.tableConfig.beforeHandle && (typeof this.tableConfig.beforeHandle == "function")) {
          this.tableConfig.beforeHandle(res.data)
        }

        this.rows = res.data;
        this.total = res[this.tableConfig.urlConfig.count];
        //   } else {
        //       this.rows = res[this.tableConfig.urlConfig.count];
        //   this.total = d[this.tableConfig.urlConfig.count];
        //   }
        //   if (res.data) {
        //     d = res.data;
        //   } else {
        //     d = res;
        //   }

        // if (this.tableConfig.type == 3) {
        //   if (res.rows) {
        //     this.rows = d[this.tableConfig.urlConfig.rows];
        //     this.total = d[this.tableConfig.urlConfig.count];
        //   } else {
        //     this.$message.warning(res.msg);
        //   }
        // } else {
        //   if (res.code == "0") {
        //     if (this.tableConfig.type == 2) {
        //       this.rows = d[this.tableConfig.urlConfig.rows];
        //     } else if (this.tableConfig.type == 3) {
        //       this.rows = d[this.tableConfig.urlConfig.rows];
        //       this.total = d[this.tableConfig.urlConfig.count];
        //     } else {
        //       this.rows = d["data"][this.tableConfig.urlConfig.rows];
        //       this.total = d["data"][this.tableConfig.urlConfig.count];
        //     }
        //   } else {
        //     this.$message.warning(res.msg);
        //   }
        // }
        //   setTimeout(() => {
        this.$nextTick(() => {
          this.loading = false;
          var tab = this.tableConfig;
          if (tab.afterHandle && (typeof this.$parent[tab.afterHandle] == "function")) {
            this.$parent[tab.afterHandle](res.data)
          }
        })
      }, err => {
        this.loading = false;
      });

      //   }, 100);
    },
    setCheckboxRow({ checkList = [], cancelList = [] }) {
      console.log("coming....")
      this.$refs.my_table.setCheckboxRow(checkList, true);
      this.$refs.my_table.setCheckboxRow(cancelList, false)
    },
    init() {
      if (this.tableConfig.singleselect) {
        this.radioConfig = {
          trigger: "row",
          labelField: "my_check",
          highlight: true,
        };
      } else {
        this.checkboxConfig = {
          trigger: "row",
          labelField: "my_check",
          highlight: true,
          range: true,
          reserve: true
        };
      }
      this.getData();
    },
    refreshColumn() {
      this.$refs["my_table"].refreshColumn();
      // this.refresh();
    },
  },

  created() {
    // document.onkeyup = (e) => {
    //   if (e.keyCode == 13) {
    //     this.refresh();
    //   }
    // };

    var q = JSON.parse(JSON.stringify(this.tableConfig.queryConfig));
    this.initParams = JSON.parse(
      JSON.stringify(this.tableConfig.queryConfig)
    );
    for (var i in q) {
      if (q[i].hidden) {
        this.originQueryHidden.push(i);
      }
      this.originQueryValueObj[i] = q[i].value;
    }
    this.init();
  },
  mounted() { },
};
</script>

<style lang="scss" scoped>
.weblist_wrap {
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  .top_wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 10px;
    .tools_wrap {
      box-sizing: border-box;
      // background: #fff;
      min-height: 38px;
      border-radius: 10px;
      padding: 0 0 15px !important;
      background: transparent;

      .my_btn {
        margin: 5px;
        background: #166df1 !important;
      }
      .slot_wrap {
        width: 100%;
      }
      .query_btn_wrap {
        display: flex;
        justify-content: flex-end;
      }
      .query_wrap {
        display: flex;
        background-color: #ffffff;
        border: 1px solid #ffffff;
        padding: 20px 0;
        box-sizing: border-box;
        border-radius: 10px;
        margin: 5px 0 10px;
        position: relative;
        display: flex;
        align-items: baseline;
        .showMore {
          position: absolute;
          border: 1px solid #ccc;
          width: 80px;
          height: 18px;
          font-size: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          left: calc(50% - 40px);
          // right: -1px;
          bottom: -18px;
          border-top: none;
          background: #f4f5f7;
          border-radius: 0 0 5px 5px;
          cursor: pointer;
          color: #409eff;
          i {
            color: #409eff;
            font-size: 20px;
          }
        }
        .query_item_wrap {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          //   padding-right: 30px;
          .query_item {
            display: flex;
            align-items: center;
            // padding: 5px 10px 5px 30px;
            // width: 33%;
            // min-width: 200px;
            .my_inp {
              width: 180px;
            }
            .lab {
              color: #5a5a5a;
              // font-weight: bold;
              padding-right: 3px;
              flex: 0 0 90px;
              font-size: 14px;
              text-align: right;
            }
            .con {
              flex: 1;
              display: flex;
              justify-content: space-between;
              .my_btn {
                width: 48%;
                margin-right: 0;
                background: #166df1;
              }
            }
          }
        }
        .query_btn_wrap {
          flex: 0 0 300px;
          .query_btn {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding-right: 20px;
            .showToggle {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #166df1;
              width: 60px;
              cursor: pointer;
              i {
                color: #166df1 !important;
              }
            }
          }
        }
        .w_25 {
          width: 25% !important;
          flex: 0 0 25%;
          .query_btn {
            width: 100%;
          }
        }
        .w_33 {
          width: 33% !important;
          flex: 0 0 33%;
          .query_btn {
            width: 100%;
          }
        }
        .w_50 {
          width: 50% !important;
          flex: 0 0 50%;
          .query_btn {
            width: 50%;
          }
        }
        .w_100 {
          width: 100% !important;
          .query_btn {
            width: 25%;
          }
        }
        .query_btn {
          // flex: 1;
          display: flex;
          .my_btn {
            width: 100%;
            background: #166df1;
            width: 100px;
          }
          .my_reset {
            background: #ffffff !important;
          }
        }
      }
    }
    .table_wrap {
      background: #fff;
      // margin-top: 20px;
      flex: 1;
      overflow: hidden;
      padding: 24px;
      box-sizing: border-box;
      width: 100%;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      .table_btn_wrap {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 20px;
        position: relative;
        .my_btn {
          background: #166df1;
        }
        &::after {
          border-bottom: 2px solid #f2f2f2;
          width: 100%;
          content: '';
          position: absolute;
          bottom: 15px;
          left: 0;
        }
      }
      .table_content_wrap {
        flex: 1;
        // padding-top: 16px;
        box-sizing: border-box;
      }
    }
  }
  .footer_wrap {
    flex: 0 0 48px;
  }
  .head_item {
    text-align: center;
    width: 100%;
  }
  .vxe-header--column.col--ellipsis {
    // height: 60px !important;
  }
  .vxe-header--column .vxe-cell {
    max-height: 80px !important;
    // height: 100% !important;
  }
  .vxe-body--column {
    height: 36px !important;
  }
  .vxe-header--column {
    background: #f2f2f2 !important;
    border-right: 1px solid #f2f2f2 !important;
  }
  .vxe-body--column.col--checkbox {
    background: #f2f2f2 !important;
    border-right: 1px solid #e8eaec !important;
  }

  .vxe-loading {
    background-color: rgba(255, 255, 255, 0.9) !important;
  }
  .vxe-pager.is--loading::after {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }
  .vxe-table--render-default .vxe-cell--checkbox .vxe-checkbox--label,
  .vxe-table--render-default .vxe-cell--radio .vxe-radio--label {
    padding-left: 0 !important;
  }
  .my_table {
    width: 100%;
  }
  .my_table .col-blue {
    color: #409eff !important;
    font-weight: bold;
    background-color: #f5f7fa;
  }
}
::v-deep .vxe-body--column.col--radio {
  background: #f2f2f2 !important;
  border-right: 1px solid #e8eaec !important;
}
.cell-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.my-link {
  height: 30px;
}
</style>
